import React, { useMemo, useState } from "react";
import { observer } from "mobx-react-lite";

import PageLayout from "../_layout/PageLayout";
import { MyAccountMenuItemsModel } from "./MyAccountMenuItems";
import { currentUserService } from "../../services/user/CurrentUserStorage";
import {
  ActionsSection,
  ButtonsSection,
} from "../../components/data-components/sections/DataSections";
import AddNewButton from "../../components/buttons/add-new-button/AddNewButton";
import { useHistory } from "react-router-dom";
import { api } from "../../services/api/ApiService";
import { OrganizationRequestsStorageModel } from "../../services/organization/OrganizationRequestsStorage";
import DataGrid from "../../components/datatable/DataGrid";

export default observer(() => {
  const history = useHistory();

  const [organizationRequestsStorage] = useState(() =>
    OrganizationRequestsStorageModel.create({ useGridFiltering: true }, { api })
  );

  const menuItems = useMemo(() => {
    const myAccountMenuItems = MyAccountMenuItemsModel.create({});

    return {
      staticItems: myAccountMenuItems.getStaticItems(),
    };
  }, []);

  const handleRequestNewOrganizationClick = () => {
    history.push("/my-account/organizations/request-organization");
  };

  return (
    <PageLayout
      titleKey="MyAccount.organization.requests"
      id="view-organizations-requests"
      menuItems={menuItems}
      isLoading={currentUserService.isLoading}
    >
      <ActionsSection>
        <ButtonsSection>
          <AddNewButton
            onClick={handleRequestNewOrganizationClick}
            buttonText="RequestNewOrganizationButton.add"
          />
        </ButtonsSection>
      </ActionsSection>
      <DataGrid
        itemTypeKey="general.organization.requests"
        dataGridStorage={organizationRequestsStorage}
        noSelection
      />
    </PageLayout>
  );
});
